import { render, staticRenderFns } from "./itc-album-sharePage.vue?vue&type=template&id=186ff592&scoped=true"
import script from "./itc-album-sharePage.vue?vue&type=script&lang=js"
export * from "./itc-album-sharePage.vue?vue&type=script&lang=js"
import style0 from "./itc-album-sharePage.vue?vue&type=style&index=0&id=186ff592&prod&lang=scss&scoped=true"
import style1 from "./itc-album-sharePage.vue?vue&type=style&index=1&id=186ff592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ff592",
  null
  
)

export default component.exports